export const FRAUD_RULE_CATEGORIES = [
  {
    id: 'visits' as const,
    slugs: ['checkin_burst', 'multi_store', 'outside_opening_hours_before'] as const
  },
  {
    id: 'rewards' as const,
    slugs: ['reward_burst'] as const
  }
] as const

export const FRAUD_RULES = FRAUD_RULE_CATEGORIES.flatMap((category) => category.slugs)

export type FraudRuleSlug = (typeof FRAUD_RULES)[number]
export type FraudRuleCategoryId = (typeof FRAUD_RULE_CATEGORIES)[number]['id']

export interface FraudSuspectEvent {
  occurredAt: string | null
  storeName: string | null
  customerMerchantId: number | null
  customerName: string | null
  phone: string | null
  subject: string | null
  points: number | null
  leadMinutes: number | null
}

export interface FraudRuleHit {
  slug: FraudRuleSlug
  pattern: string | null
  eventCount: number
  windowStartedAt: string | null
  windowEndedAt: string | null
  events: FraudSuspectEvent[]
}

export type FraudSuspectStatus = 'ALERTE' | 'SURVEILLANCE'

export interface SuspectCustomer {
  id: number
  name: string | null
  phone: string | null
  storeName: string | null
  status: FraudSuspectStatus
  rules: FraudRuleHit[]
}
